import { max, map, unzip, each, compact, set } from 'lodash';
export function computeLayout(titles, separator) {
    const colHeaders = titles.map(title => title.split(separator));
    const headRowsCount = max(map(colHeaders, 'length'));
    let data = colHeaders.map(col => col.map((name, i) => {
        const isLast = i === col.length - 1;
        return {
            name,
            rowSpan: isLast ? headRowsCount - col.length + 1 : undefined,
            colSpan: 1,
            isLast,
        };
    }));
    data = unzip(data);
    data.forEach(row => {
        let spanningCell = null;
        each(row, (col, i) => {
            set(row[i], 'colIndex', i);
            if (col && spanningCell && col.name === spanningCell.name) {
                /* eslint-disable no-param-reassign,@typescript-eslint/ban-ts-comment */
                // @ts-ignore
                row[i] = undefined;
                if (spanningCell)
                    spanningCell.colSpan += 1;
            }
            else
                spanningCell = col;
        });
    });
    return data.map(compact);
}
//# sourceMappingURL=computeLayout.js.map